/*
 * GETMAN - PDP information tabs (snippets/getman-pdp-tabs.liquid).
 *
 * ARIA tab pattern: click / Enter / Space activates a tab; Left/Right/Up/Down
 * and Home/End move between tabs. Activating a tab shows its panel and hides
 * the others. Delegated from document so it keeps working after the product
 * section re-renders (variant change).
 */
(function () {
  if (window.__gmPdpTabsBound) return;
  window.__gmPdpTabsBound = true;

  function tabsIn(list) {
    return Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
  }

  function activate(list, tab) {
    tabsIn(list).forEach(function (t) {
      var selected = t === tab;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      t.tabIndex = selected ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.gm-pdp-tabs [role="tab"]');
    if (!tab) return;
    activate(tab.closest('[role="tablist"]'), tab);
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('.gm-pdp-tabs [role="tab"]');
    if (!tab) return;
    var list = tab.closest('[role="tablist"]');
    var all = tabsIn(list);
    var i = all.indexOf(tab);
    var next;

    switch (event.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = all[(i + 1) % all.length];
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = all[(i - 1 + all.length) % all.length];
        break;
      case 'Home':
        next = all[0];
        break;
      case 'End':
        next = all[all.length - 1];
        break;
      default:
        return;
    }

    event.preventDefault();
    activate(list, next);
    next.focus();
  });
})();
